export var Urls;
(function (Urls) {
    // Customer Postbox Service URLs
    Urls.PostboxUnreadThreadsCount = (bacNumber) => `/threads/unread-count?customer_id=${bacNumber}`;
})(Urls || (Urls = {}));
//# sourceMappingURL=urls.js.map